import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';
import styles from './submit-event-button.scss';

/**
 * SubmitEventButton component displays a call-to-action for users to submit their own events
 * Supports visibility and text customization via settings
 */
function SubmitEventButton({ settings, className = '' }) {
  // Check if component should be shown
  if (!settings.get('showSubmitEvent')) {
    return null;
  }

  const requestNewEventUrl = settings.get('requestNewEventUrl');

  // If no URL is configured, don't render the button
  if (!requestNewEventUrl) {
    return null;
  }

  // const labelText = settings.get('submitEventLabelText', 'Have idea for an event?');
  const buttonText = settings.get('submitEventButtonText', 'Submit Event');

  const handleClick = () => {
    // Open URL in new tab
    window.open(requestNewEventUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={cn(styles.submitEventButtonContainer, 'submit-event-container', className)}>
      <div className={styles.submitEventContent}>
        {/* <span className={cn(styles.submitEventLabel, 'submit-event-label')}>{labelText}</span> */}
        <button className={cn(styles.submitEventButton, 'submit-event-button')} onClick={handleClick} type="button">
          {buttonText}
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(styles.submitEventIcon, 'submit-event-icon')}
          >
            <path
              d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M10 2H14V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.66667 9.33333L14 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
}

SubmitEventButton.propTypes = {
  settings: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
};

export default SubmitEventButton;
